import { cn } from "./utils";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
}

const sizeClasses = {
  sm: "h-4 w-4 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-12 w-12 border-3",
};

export function Spinner({ size = "md", className, label }: SpinnerProps) {
  return (
    <div className="flex items-center justify-center py-12">
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-transparent border-t-primary",
          sizeClasses[size],
          className
        )}
      />
      {label && <span className="ml-3 text-muted-foreground">{label}</span>}
    </div>
  );
}
